module.exports = "/desktop-app/assets/img/phone.svg?0c8394fbfb13c1ba66f9194183111c3e";


//////////////////
// WEBPACK FOOTER
// ./foody/src/assets/common/svg/phone.svg
// module id = KuJ2
// module chunks = 1